import { EpimsBaseEntityDto } from './epim-base.dto';
export class ObligationRegisteredFacilityDto extends EpimsBaseEntityDto {

   LandTitleId: string;
   FacilityName: string;
   FacilityId: string;
   CompanyValue: number;
   LGAValue: number;
   AgreedValue: number;
   Comments: string;
   SubscriptionUserId: string;

}
